module.exports = __webpack_public_path__ + "media/images/logos/Asclepius-Consultancy_logo-6325ae9a4e258fe9437be185b5467738.jpg";